<template>
<div style="position:relative">
    <input ref="search" v-validate="validate" id="app" @change="cleanData(userInput)" :name="name" 
    :class="{'form-control form-control-sm': true, 'is-invalid': errors.has(name) }" type="text" 
    :value="userInput" @input="input($event)" @blur="hide()" @focus="show()" :disabled="unEdit">
    <div style="position:absolute;width:100%;z-index:3">
        <div :style="myStyle">
            <ul v-bind:style="ulSeen">
                <li v-for="(item,index) in list " @mousedown="change(index)" :key="index" style="text-align:left">
                    {{item[bindProp]}}
                </li>
            </ul>
        </div>
    </div>
    <span v-show="errors.has(name)" class="lbl-obg">{{ errors.first(name) }}</span>
</div>
</template>

<style scoped>
::-webkit-scrollbar {
    width: 4px;
    height: 4px;
    background-color: #F5F5F5;
}

::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    background-color: #FFF;
}

::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
    background-color: #AAA;
}

li:hover {
    color: #fff;
    background-Color: #1E90FF;
    cursor: pointer
}
</style>

<script>
import {
    mapState
} from "vuex";
export default {
    name: "mmf-dimSearch",
    props: {
        // 组件绑定的实体数组
        'entity': {
            type: Array,
            default: []
        },
        //validate和name具体参考v-validate，可不使用
        'validate': {
            default: ''
        },
        'name': {
            default: ''
        },
        // 用于 dimsearch 组件之间的绑定的， 需要绑定在一起的组件 bindId 必须相同
        'bindId': {
            type: String,
            default: '',
        },
        // 组件展示的属性名
        'bindProp': {
            type: String,
            default: ''
        },
        'value': {},
        // 组件 v-model 提交的属性名
        'submitProp': {
            type: String,
            default: ''
        },
        'unEdit':{
            tyep: Boolean,
            default: false
        }
    },
    data: () => {
        return {
            //样式
            ulSeen: {
                listStyle: 'none',
                'padding-inline-start': 0,
                'margin-bottom': 0,
            },
            myStyle: {
                background: '#fff',
                height: '0px',
                overflow: 'auto',
                display: 'none',
                width: '100%',
                border: '1px solid #999',
            },
            userInput: '',
            active: false,
            submitPropInside: '',
            unbind: true
        }
    },
    methods: {
        cleanData(value){
            if(value === null || value === "")
                this.$store.dispatch("dimSearch/initBind", {
                    [this.bindId]: {}
                })
            
        },
        show() {
            this.active = true
            this.myStyle.display = 'block'
        },
        hide() {
            this.active = false
            this.myStyle.display = 'none'
        },
        //选项修改，更改仓库中绑定的数据
        change(value) {
            this.$store.dispatch("dimSearch/initBind", {
                [this.bindId]: this.list[value]
            })
            this.userInput = this.list[value][this.bindProp]
        },
        input(e) {
            if (this.$refs.search.composing == false) this.userInput = e.target.value;
        },
        onCompositionStart(e) {
            e.target.composing = true
        },
        onCompositionEnd(e) {
            e.target.composing = false
            this.userInput = e.target.value;
        }
    },
    computed: {
        ...mapState('dimSearch', ['bindedStatus']),
        bindStatus() {
            return this.bindedStatus;
        },
        list() {
            let prop = this.bindProp
            let lists = new Array();
            let targets = this.entity;
            let has = false
            for (let i of targets) {
                if (i[prop] === undefined || this.userInput === undefined) {
                    continue;
                }
                let fprop = typeof i[prop] == 'number' ? i[prop].toString() : i[prop]
                let fuserInput = typeof this.userInput == 'number' ? this.userInput.toString() : this.userInput
                if (fprop.toLowerCase().search(fuserInput.toLowerCase()) != -1) {
                    lists.push(i)
                    has = true;
                }
            }
            if (!has) {
                lists = targets
            }
            return lists
        }
    },

    watch: {
        bindStatus: function() {
            if(typeof this.bindStatus[this.bindId] != 'undefined') {
                let b = this.bindStatus[this.bindId][this.submitProp]
                this.userInput = this.bindStatus[this.bindId][this.bindProp];
                if(typeof b != 'undefined')
                    this.$emit('input', typeof b == 'number' ? b.toString() : b)
            }
        },
        //监听list大小以改变样式
        list: {
            handler(val) {
                //如果当前输入查不到结果，则置空
                if (val === this.entity && val.length > 1) {
                    //console.log('置空'+this.bindProp)
                    this.userInput = ''
                }
                val.length > 6 ? this.myStyle.height = '112.4px' : this.myStyle.height = val.length * 18.4 + 2 +
                    'px'
            },
            deep: true,
            immediate: true,
        },
        //监听传入列表改变并重新修改list
        entity: {
            handler(val) {
                // console.log('进入entity监听'+this.bindProp)
                if (typeof this.value == 'undefined') return
                for (let i of val) {
                    //console.log(i[this.submitPropInside]+'   '+this.value)
                    if (i[this.submitPropInside] === this.value) {
                        //绑定的话就推到仓库
                        if (!this.unbind)
                            this.$store.dispatch("dimSearch/initBind", {
                                [this.bindId]: i
                            })
                        //不绑定的话就只更新内部userInput
                        else this.userInput = i[this.bindProp]
                    }
                }
                //this.getList();
                //console.log('退出entity监听'+this.bindProp)
            },
            deep: true,
            immediate: true,

        },
        //在外界value改变时会监听到变化然后再重新从entity中选择，找不到的话就置为空
        value(val) {
            // console.log('进入value监听'+this.bindProp)
            if (typeof val == 'undefined') return
            let has = false;
            for (let i of this.entity) {
                //console.log(i[this.submitPropInside] + '   ' + val)
                if (i[this.submitPropInside] == val) {
                    //绑定的话就推到仓库
                    if (!this.unbind && !this.unEdit)
                        this.$store.dispatch("dimSearch/initBind", {
                            [this.bindId]: i
                        })
                    //不绑定的话就只更新内部userInput
                    else this.userInput = i[this.bindProp]
                    has = true;
                }
            }
            if (!has) {
                //绑定的话就推到仓库
                if (!this.unbind)
                    this.$store.dispatch("dimSearch/initBind", {
                        [this.bindId]: {}
                    })
                //不绑定的话就只更新内部userInput
                else this.userInput = ''
            }
            //console.log('退出entity监听'+this.bindProp)
        }
    },
    //初始化
    mounted() {
        //如果没有bindId,就不同步
        if (this.bindId != '') this.unbind = false;
        //submitProp默认等于bindProp
        if (this.submitProp == '') {
            this.submitPropInside = this.bindProp;
        } else {
            this.submitPropInside = this.submitProp
        }
        var el = this.$refs.search
        el.composing = false;
        el.addEventListener('compositionstart', this.onCompositionStart)
        el.addEventListener('compositionend', this.onCompositionEnd)
    },
    beforeDestroy() {
        this.$store.dispatch("dimSearch/deleteProp", this.bindId)
    },
}
</script>
